import { createCameraDetailsLookup } from '@simplisafe/compass-web'

export const lookupCameraDetails = createCameraDetailsLookup({
  // Throw on unknown models outside production so they surface in development and tests.
  // In production, compass-web logs the error and returns undefined instead.
  throwOnUnknownModel: !import.meta.env.PROD
})

export const getDisplayName = (model?: string): string | undefined => {
  // lookupCameraDetails will throw/log if the model is unknown.
  // a missing model property doesn't necessarily indicate an unknown camera model,
  // it could be that an API hasn't fully populated the model property yet.
  if (model) {
    return lookupCameraDetails(model)?.displayName
  }
}
